module.exports = __webpack_public_path__ + "img/flowers9.07c6cdba.jpg";